import { render, staticRenderFns } from "./DeathCause.vue?vue&type=template&id=777a3f0d&scoped=true&"
import script from "./DeathCause.vue?vue&type=script&lang=js&"
export * from "./DeathCause.vue?vue&type=script&lang=js&"
import style0 from "./DeathCause.vue?vue&type=style&index=0&id=777a3f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777a3f0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VForm,VIcon,VRow,VTextField})
